(function() { window.GUID_ff99bc1a_c51d_45e2_b513_0bb1384c752c = { getGuid: function() { return "ff99bc1a-c51d-45e2-b513-0bb1384c752c"; } }; })();
//alert('test'); 

//# sourceMappingURL=test.js.map
